<template>
  <div class="assigned-tests" v-if="areThereAnyTests">
    <h3 class="section-title">
      {{ $t("KNOWLEDGE_TEST_FOCUS_TITLE") }}
    </h3>

    <div
      class="card knowledge-test-card"
      v-for="test in knowledgeTestsArray"
      :key="test.id"
      :class="{ 'knowledge-test-warning' : !didUserPassTest(test.id) && isTestClosingSoon(test.id) }"
    >
      <div class="test-specific-part">
        <div class="test-name-row">
          <h2>{{ test.title || $t("KNOWLEDGE_TEST_FOCUS_TITLE") }}</h2>
          <span class="label label-important test-deadline-label">
            {{ "KNOWLEDGE_TEST_DEADLINE" | translate }} {{ test.open_to_formatted }}
          </span>
        </div>

        <div class="test-status-row">
          <p class="previous-attempt attempt-running"
             v-if="isAttemptForTestActive(test.id)"
          >
            {{ "KNOWLEDGE_TEST_UNFINISHED_ATTEMPT" | translate }}
          </p>

          <template v-else-if="!isEmpty(bestTestAttempt(test.id))">
            <!-- test is waiting for manual evaluation -->
            <p class="previous-attempt attempt-manual"
               v-if="bestTestAttempt(test.id).result === null"
            >
              <span class="label label-default">
                {{ "KNOWLEDGE_TEST_PREVIOUS_MANUAL" | translate }}
              </span>
            </p>

            <!-- test already has a result - stays visible even once passed -->
            <p class="previous-attempt" v-else
               :class="bestTestAttempt(test.id).result === true ? 'attempt-success' : 'attempt-fail'"
            >
              {{ "KNOWLEDGE_TEST_YOUR_RESULT" | translate }}
              {{ bestTestAttempt(test.id).percentage }}%
              <span class="label label-success" v-if="bestTestAttempt(test.id).result === true">
                {{ "KNOWLEDGE_TEST_PREVIOUS_SUCCESS" | translate }}
              </span>
              <span class="label label-danger" v-else>
                {{ "KNOWLEDGE_TEST_PREVIOUS_FAIL" | translate }}
              </span>
            </p>
          </template>

          <p class="test-attempts-count"
             v-if="!isAttemptForTestActive(test.id)"
          >
            <template v-if="remainingTestAttempts(test.id) === 0">
              {{ "KNOWLEDGE_TEST_ATTEMPTS_0" | translate }}
            </template>
            <template v-else-if="remainingTestAttempts(test.id) === 1">
              {{ "KNOWLEDGE_TEST_ATTEMPTS_1" | translate }}
            </template>
            <template v-else-if="remainingTestAttempts(test.id) <= 4">
              {{ $t("KNOWLEDGE_TEST_ATTEMPTS_2_4", { count : remainingTestAttempts(test.id) }) }}
            </template>
            <template v-else>
              {{ $t("KNOWLEDGE_TEST_ATTEMPTS_5_MORE", { count : remainingTestAttempts(test.id) }) }}
            </template>
          </p>
        </div>

        <div class="test-button-row">
          <button
            class="btn primary-btn"
            @click="continueAttempt()"
            v-if="isAttemptForTestActive(test.id)"
          >
            {{ "KNOWLEDGE_TEST_CONTINUE_ATTEMPT" | translate }}
          </button>
          <button
            class="btn primary-btn"
            @click="showStartModal(test.id)"
            v-else
            :disabled="remainingTestAttempts(test.id) === 0 || isAnyAttemptActive"
          >
            {{ "KNOWLEDGE_TEST_START_ATTEMPT" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<!---------------------------------------------------------------------------->
<script>
import { mapGetters } from "vuex";
import isEmpty from "lodash/isEmpty";

import notificationService from "src/services/notificationService";
import userMessages from "src/services/userMessages";
import log from "src/services/logger";

const logTag = "AssignedTests";

export default {
  name: "AssignedTests",

  watch: {
    // tests are scoped to the area sent in the x-ifo-area header, so we can only download them once
    // the current area is settled - CategoryChooser switches it asynchronously via changePreferredArea
    currentAreaId: {
      immediate: true,
      handler(areaId) {
        if (!areaId) {
          return;
        }
        this.$store.dispatch("downloadKnowledgeTests").catch((reason) => {
          log.log(logTag, "Download of knowledge tests failed, reason follows");
          log.log(logTag, reason);
        });
      },
    },
  },

  computed: mapGetters([
    "currentAreaId",
    "areThereAnyTests", "knowledgeTestsArray", "currentAreaCssClass", "knowledgeTests",
    "isAttemptForTestActive", "isAnyAttemptActive", "remainingTestAttempts", "bestTestAttempt",
    "isTestClosingSoon", "didUserPassTest",
  ]),

  methods: {
    isEmpty,

    showStartModal(testId) {
      notificationService.knowledgeTestGeneric(
        this.knowledgeTests[testId].title,
        this.$t("KNOWLEDGE_TEST_MODAL_TITLE"),
        this.knowledgeTests[testId].description,
        this.currentAreaCssClass,
        (result) => {
          if (result === true) {
            // ONLY this component, KnowledgeTestBox and TestResult can start a new test attempt!
            this.$store.dispatch("startTestAttempt", testId)

            .then(() => {
              this.$router.push("/test");
            })

            .catch((reason) => {
              log.log(logTag, "Start test attempt - error, reason follows:");
              log.log(logTag, reason);
              this.$store.dispatch("showErrorMessage", userMessages.afterStartTestAttempt(reason));
              // we might have had old test data - redownload
              this.$store.dispatch("downloadKnowledgeTests");
            });
          }
        }
      );
    },

    continueAttempt() {
      this.$router.push("/test");
    },
  },
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
